var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const extractLayoutProps = (_a) => {
    var { name, label, secondaryLabel, tertiaryLabel, helperText, error, invalid, hidden } = _a, rest = __rest(_a, ["name", "label", "secondaryLabel", "tertiaryLabel", "helperText", "error", "invalid", "hidden"]);
    const layoutProps = {
        name,
        label,
        secondaryLabel,
        tertiaryLabel,
        helperText,
        error,
        invalid,
        hidden,
    };
    const inputProps = Object.assign({ id: name, name,
        invalid }, rest);
    return { layoutProps, inputProps };
};
//# sourceMappingURL=utils.js.map